import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Main from 'components/Main'
import Auth0ApiProvider from 'components/auth0ApiProvider'
import { useAuth0 } from 'lib/auth0-api'

const Logout = () => {
  const { logout } = useAuth0()
  useEffect(() => {
    console.log(window.location.origin)
    logout({ returnTo: window.location.origin })
  }, [logout])

  return null
}

const Auth0ProtectedPage = () => {
  const [shouldLogout, setShouldLogout] = useState(false)
  const { query } = useRouter()

  useEffect(() => {
    if (query?.action === 'logout') {
      setShouldLogout(true)
    }
  }, [query])

  return (
    <Auth0ApiProvider>
      {shouldLogout && <Logout />}
      <Main />
    </Auth0ApiProvider>
  )
}

export default Auth0ProtectedPage
